<template>
	<!-- Complete component -->
	<div class="b-complete rounded" v-style_full="{ border_color: color }">
		<!-- Section Title -->
		<div class="b-title pointer" v-style_title="{ background_color: color, t_color: title_color, t_align: title_align, t_size: title_size}" @click="changeStatusExpand()">
			<div class="row pointer" v-if="expandable">
				<div class="col-1 px-0 mx-0" v-if="left">
					<mu-icon class="align-self-center pl-2" value="expand_more" :size="36"></mu-icon>
				</div>
				<div class="col-11 pointer">
					<label class="title pointer"> <fa v-if="icon" size="2xs" icon="circle" v-style_icon="{t_color: icon_color}" class="mr-2" /> {{ title }} </label>
					<label class="subtitle pointer" v-if="subtitle !== undefined">{{ subtitle }}</label>
				</div>
				<div class="col-1 d-flex flex-row-reverse" v-if="!left">
					<mu-icon class="align-self-center" :value="expand_content ? 'expand_less': 'expand_more'" :size="36"></mu-icon>
				</div>
			</div>
			<div class="row" v-else>
				<div class="col-12 pointer">
					<label class="title pointer"> {{ title }} </label>
					<label class="subtitle pointer" v-if="subtitle !== undefined">{{ subtitle }}</label>
				</div>
			</div>
		</div>
		
		<!-- Section content -->
		<div v-if="expand_content" transition="expand">
			<div class="row px-2">
				<div class="col-12">
					<slot>
						
					</slot>
				</div>
			</div>

			<!-- Section buttons -->
			<div class="row px-2">
				<div class="col-12 text-center">
					<slot name="buttonsArea">
						
					</slot>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'bcard',
		data() {
			return {
				content: 'Contenido',
				expand_content: true,
				expand_icon: false,
			}
		},
		props: {
			title: {
				require: false,
				type: String,
				default: 'DEFAULT TITLE'
			},
			subtitle: {
				require: false,
				type: String
			},
			title_align: {
				require: false,
				type: String,
				default: 'left',
				validator: function (value) {
			        // El valor debe coincidir con una de estas cadenas de texto
			        return ['left', 'right', 'center'].indexOf(value) !== -1
			    }
			},
			title_color: {
				require: false,
				default: 'white'
			},
			title_size: {
				require: false,
				type: Number,
				default: 0
			},
			icon: {
				require: false,
				default: false
			},
			icon_color: {
				require: false,
				default: '#005296'
			},
			color: {
				require: false,
				default: '#005296'
			},
			expandable: {
				require: false,
				type: Boolean,
				default: false
			},
			expanded: {
				require: false,
				type: Boolean,
				default: true
			},
			left: {
				require: false,
				type: Boolean,
				default: false
			},
			height: {
				require: false,
				type: Number,
				default: 100
			}
		},
		directives: {
			'style_full': {
				bind(el, binding, vnode) {
                    // console.log(el.style,'el style')
                    // console.log(binding,'binding')
                    // console.log(vnode,'vnode')
                    
                    el.style.borderColor = binding.value.border_color
                },
			},
			'style_title': {
				bind(el, binding, vnode) {
					// console.log(el.style,'el style')
                    
                    el.style.backgroundColor = binding.value.background_color
                    el.style.color = binding.value.t_color
                    el.style.textAlign = binding.value.t_align
                    if(binding.value.t_size != 0) {
                    	el.style.fontSize = binding.value.t_size.toString() + "px"
                    }
                    

                },
			},
			'style_icon': {
				bind(el, binding, vnode) {

                    el.style.color = binding.value.t_color

                },
			}
		},
		methods: {
			changeStatusExpand() {
				if(this.expandable == true) {
					this.expand_content = !this.expand_content	
				}
			}
		},
		created() {
			if(this.expandable == true) {
				this.expand_content = this.expanded
			}
		}
	}
</script>

<style>
	/* Main container styles*/
	.pointer{
		cursor: pointer !important;
	}
	.b-complete {
		background-color: white !important;
		border: 1px solid black;
		border-radius: 10px;
		/*min-width: 300px;*/
		width: 100%;
    }
    .b-title {
    	/*background-color: green !important;*/
		border-top-left-radius: 7px;
		border-top-right-radius: 7px;
		/*min-width: 300px;*/
		width: 100%;
		cursor:pointer;
    }
    .title {
    	font-family: Roboto-Condensed;
    	font-size: 1.3em;
    	padding: 5px;
    	margin: auto;
		width: 100%
    }
    .subtitle {
    	font-family: Roboto-Condensed;
    	margin: 0px 0px 5px .2em;
    	font-style: italic;
    	font-size: 1em;
    	padding: 0px;
    	width: 100%
    }
    .expand-transition {
		transition: all .3s ease;
		height: 30px;
		padding: 10px;
		background-color: #eee;
		overflow: hidden;
	}
	.expand-enter, .expand-leave {
		height: 10px;
		padding: 0 10px;
		opacity: 0;
	}
</style>